import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogoMonogram } from '@teivor/shared-ui';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-[var(--color-bg)] px-4 text-[var(--color-fg)]">
      <LogoMonogram width={64} height={64} className="mb-6" />
      <h1 className="mb-2 text-6xl font-bold tracking-tight">404</h1>
      <p className="mb-6 max-w-md text-center text-sm text-[var(--color-fg-secondary)]">
        {t('errors.not_found', 'The page you are looking for could not be found.')}
      </p>
      <Link
        to="/"
        className="inline-flex h-9 items-center rounded-[var(--radius-md)] bg-[var(--color-accent)] px-4 text-sm font-medium text-white hover:bg-[var(--color-accent-hover)]"
      >
        {t('errors.go_home', 'Go home')}
      </Link>
    </div>
  );
}
